export default {
  'moduleTitle.address': 'Naslov',
  'moduleTitle.address_details': 'Naslov',
  'moduleTitle.activity_details': 'Podatki o dejavnosti',
  'moduleTitle.add_log': 'Dodaj dnevniški vnos',
  'moduleTitle.award_level': 'Stopnja programa',
  'moduleTitle.adventurous_journey': 'Pustolovska odprava',
  'moduleTitle.already_assessed': 'Že ocenjeno!',
  'moduleTitle.approved': 'Odobreno!',
  'moduleTitle.assessor_details': 'Podatki o ocenjevalcu',
  'moduleTitle.authorising_contact_license_holder': 'Zakoniti zastopnik organizacije',
  'moduleTitle.category_journey_details': 'Podatki o odpravi – {category}',
  'moduleTitle.complete_report': 'Celotno poročilo',
  'moduleTitle.completed_progress': 'Opravljeno {finished}/{total}',
  'moduleTitle.congratulation': 'Čestitke!',
  'moduleTitle.confirming_email_address': 'Potrjevanje e-naslova ...',
  'moduleTitle.contact_details': 'Kontaktni podatki',
  'moduleTitle.edit_log': 'Uredi dnevniški vnos',
  'moduleTitle.event_journey': 'Odprava – {event}',
  'moduleTitle.forgotten_password': 'Pozabljeno geslo',
  'moduleTitle.great_you_are_almost_there': 'Pravilnik o zasebnosti',
  'moduleTitle.home_address': 'Domači naslov',
  'moduleTitle.journey_overview': 'Pregled odprave',
  'moduleTitle.log_detail': 'Podrobnosti o dnevniškem vnosu',
  'moduleTitle.login': 'Prijava',
  'moduleTitle.new_activity': 'Nova dejavnost',
  'moduleTitle.new_event_journey': 'Nova odprava – {event}',
  'moduleTitle.new_residential_project': 'Nov PNP',
  'moduleTitle.notRegistred': 'Ali še nisi registriran/-a?',
  'moduleTitle.nominated_award_leader_contact_details': 'Kontaktni podatki koordinatorja',
  'moduleTitle.nominated_award_leader': 'Koordinator',
  'moduleTitle.organisation_address': 'Naslov organizacije',
  'moduleTitle.organisation_details': 'Podatki o organizaciji',
  'moduleTitle.online_record_book_account': 'Račun v spletnem indeksu dosežkov',
  'moduleTitle.page_not_found': '404 – strani ni bilo mogoče najti',
  'moduleTitle.personal_details': 'Osebni podatki',
  'moduleTitle.preparation_and_training': 'Priprave na odpravo',
  'moduleTitle.profile_guardian_consent': 'Soglasje starša/skrbnika',
  'moduleTitle.profile_questions': 'Predstavitvena vprašanja',
  'moduleTitle.registration_for_level': 'Registracija za naslednjo stopnjo',
  'moduleTitle.residential_project': 'Projekt Neznani prijatelj',
  'moduleTitle.residential_project_details': 'Podrobnosti o projektu Neznani prijatelj',
  'moduleTitle.reset_password': 'Ponastavitev gesla',
  'moduleTitle.welcome_to_the_orb': 'Dobrodošli v spletnem indeksu dosežkov',
  'moduleTitle.we_have_sent_you_an_email': 'Poslali smo vam e-poštno sporočilo s povezavo za aktivacijo.',
  'moduleTitle.your_registration_is_complete': 'Registracija je zaključena.',
  'formTitle.activity_details': 'Podatki o dejavnosti',
  'formTitle.assessor_details': 'Podatki o ocenjevalcu',
  'formTitle.supervisors_details': 'Podrobnosti o spremljevalcu',
  'formTitle.preparation_and_training_activities': 'Priprave na odpravo',
  'formTitle.added_preparation_activities': 'Dodatne priprave na odpravo',
  'label.add_picture': 'Dodajanje slike',
  'label.address_first_line': 'Ulica in hišna številka',
  'label.address_second_line': 'Dodatna vrstica za naslov (neobvezno)',
  'label.are_you_already_running_award': 'Ali že izvajate program MEPI?',
  'label.are_you_the_main_award_leader': 'Ali ste koordinator v svoji izvajalski organizaciji?',
  'label.award_participant': 'Udeleženec programa',
  'label.award_leader': 'Mentor',
  'label.birthdate': 'Datum rojstva',
  'label.category': 'Kategorija',
  'label.change_locale': 'Sprememba kraja',
  'label.choose_project': 'Izbira dejavnosti',
  'label.city': 'Mesto',
  'label.choose_as_major_activity': 'Določitev glavne dejavnosti',
  'label.date': 'Datum',
  'label.date_of_birth': 'Datum rojstva',
  'label.description_of_progress': 'Opis tvojega napredka',
  'label.duration': 'Trajanje (ure/minute)',
  'label.email': 'E-naslov',
  'label.email_address': 'E-naslov',
  'label.email_again': 'Potrditev e-naslova',
  'label.employment_status': 'Stanje zaposlitve',
  'label.end_date': 'Datum konca',
  'label.enter_his_email': 'Vnos e-naslova',
  'label.entered_transaction_id': 'ID transakcije',
  'label.first_name': 'Ime',
  'label.gender': 'Spol',
  'label.goal': 'Cilj',
  'label.journey_activity': 'Vrsta dejavnosti',
  'label.journey_objective': 'Namen odprave',
  'label.journey_observations': 'Opažanja na odpravi',
  'label.journey_type': 'Vrsta odprave',
  'label.last_name': 'Priimek',
  'label.level': 'Stopnja',
  'label.location': 'Kraj',
  'label.logout': 'Odjava',
  'label.major': 'Glavna dejavnost',
  'label.middle_name': 'Drugo ime',
  'label.mode_of_transport': 'Način potovanja',
  'label.my_award_leader': 'Moj mentor',
  'label.name': 'Ime',
  'label.nationality': 'Državljanstvo',
  'label.no': 'Ne',
  'label.no_results': 'Ni rezultatov',
  'label.note': 'Opomba',
  'label.note_for_assessor': 'Opomba za ocenjevalca',
  'label.note_for_leader': 'Opomba za mentorja',
  'label.optional': 'izbirno',
  'label.organisation_name': 'Ime organizacije',
  'label.organisation_type': 'Vrsta organizacije',
  'label.others': 'Drugo',
  'label.password': 'Geslo',
  'label.password_again': 'Ponovitev gesla',
  'label.project_location': 'Kraj projekta',
  'label.pay_online': 'Spletno plačilo',
  'label.pay_award_leader_or_unit': 'Plačilo mentorju ali organizaciji',
  'label.payment_not_required': 'Plačilo ni potrebno',
  'label.payment_type': 'Vrsta plačila:',
  'label.phone': 'Telefon',
  'label.phone_number': 'Telefonska številka',
  'label.phone_type': 'Vrsta telefona',
  'label.profile': 'Profil',
  'label.reset_password': 'Ponastavitev gesla',
  'label.region': 'Statistična regija',
  'label.relationship': 'Razmerje',
  'label.role_in_organisation': 'Vloga v organizaciji',
  'label.select_country': 'Izbira države',
  'label.select_your_au': 'Izbira izvajalske organizacije',
  'label.start_typing': 'Začnite tipkati ...',
  'label.start_date': 'Datum začetka',
  'label.select': 'Izberi',
  'label.select_async': 'Začnite tipkati ...',
  'label.select_your_operating_authority': 'Izbira nacionalnega urada',
  'label.specify_category': 'Izbira kategorije',
  'label.subcategory': 'Podkategorija',
  'label.title': 'Naziv',
  'label.username': 'Uporabniško ime',
  'label.what_is_your_role': 'Kakšna je vaša vloga v organizaciji?',
  'label.where_have_you_completed': 'V kateri organizaciji si zaključil/-a predhodno stopnjo?',
  'label.yes': 'Da',
  'label.your_changes_havent_been_saved': 'Spremembe niso bile shranjene. Podatki bodo izgubljeni.',
  'label.zip': 'Poštna številka',
  'label.adventurous_journey': 'Pustolovska odprava',
  'label.after_your_journey_describe': 'V nekaj stavkih opiši svoja opažanja na odpravi.',
  'label.because_your_age_is_under_18': 'Ker še nimaš 18 let, potrebujemo soglasje tvojih staršev/skrbnikov.',
  'label.before_you_head_to_journey': 'Preden lahko nadaljuješ s kvalifikacijsko odpravo, moraš najprej zaključiti priprave na odpravo.',
  'label.before_entering_new_level': 'Pred začetkom opravljanja dejavnosti na naslednji stopnjo potrdi, da so tvoji osebni podatki še veljavni.',
  'label.bring_required_amount_to_your_award_leader': 'Pristopnino prinesi mentorju ali koordinatorju v svoji izvajalski organizaciji.',
  'label.do_you_have_any_other_level': 'Ali si že dokončal katero izmed predhodnih stopenj?',
  'label.do_you_know_who_is_your_award_leader': 'Ali veš, kdo je tvoj mentor?',
  'label.going_on_an_expedition': 'Ko greš na odpravo, doživiš dogodivščino in v ekipi sodeluješ s svojimi predlogi.',
  'label.going_on_residential_gives_chance': 'Projekt Neznani prijatelj ti omogoča, da se naučiš dela z ljudmi iz različnih okolij in razviješ samozavest med bivanjem v neznanem okolju.',
  'label.i_confirm_that_i_meet': 'Potrjujem, da izpolnjujem vse zahteve nacionalnega urada.',
  'label.i_agree_to_volunteer_code': 'Soglašam z Etičnim kodeksom organiziranega prostovoljstva. Klikni za več informacij.',
  'label.i_have_read_the_terms_and_conditions': 'Prebral/-a sem pogoje in se z njimi strinjam.',
  'label.i_will_bring_the_consent_to_my_award_leader_later': 'Soglasje bom mentorju prinesel/-a pozneje.',
  'label.if_you_are_from_orphanage': 'Če na primer tvoja šola ali mladinska organizacija plača zate.',
  'label.here_you_can_add_activity': 'Tu lahko dodaš dodatne priprave na odpravo.',
  'label.how_do_you_want_to_apply': 'Kako se želiš prijaviti:',
  'label.my_parent_consent_has_been_already_given': 'Mentor je že prejel moje soglasje starša/skrbnika.',
  'label.my_parent_will_confirm_consent_by_email': 'Moji starši/skrbniki bodo soglasje potrdili prek e-pošte.',
  'label.major_activity_means_that_you_have_to_spent': 'Glavna dejavnost pomeni, da je v primerjavi z drugimi za to dejavnost treba porabiti več časa. Na zlati in srebrni stopnji to pomeni šest mesecev, na bronasti  stopnji pa tri mesece.',
  'label.not_sure_about_your_auth': 'V primeru težav pri registraciji se obrnite na nacionalni urad.',
  'label.page_not_found': '404 – strani ni bilo mogoče najti',
  'label.please_fill_in_the_following': 'Vnesi sledeče podatke o stiku za pooblastitev/imetniku licence pri svoji organizaciji.',
  'label.register_a_new_account_as': 'Registriraj se kot:',
  'label.residential_project': 'Projekt Neznani prijatelj',
  'label.select_your_award_unit': 'Izbira izvajalske organizacije',
  'label.the_expedition_can_be_faraway': 'Odprava je lahko tako blizu ali tako daleč od doma, kot hočeš, in lotiš se je lahko na stotine načinov.',
  'label.to_log_your_process_on_orb': 'Spodaj določi geslo in tako dokončaj ustvarjanje računa v spletnem indeksu dosežkov.',
  'label.waiting_for_assessment': 'Čakanje na oceno.',
  'label.waiting_for_sign_off': 'Čakanje na potrditev mentorja.',
  'label.we_have_sent_you_an_email': 'Poslali smo ti e-poštno sporočilo z aktivacijsko povezavo.',
  'label.what_level_of_the_award': 'Za katero stopnjo programa se želiš registrirati?',
  'label.you_are_now_registering_as_participant': 'Nameravaš se registrirati kot udeleženec programa.',
  'label.you_are_now_registering_as_award_unit': 'Registrirali se boste kot izvajalska organizacija.',
  'label.you_can_use_my_photos_for_promotional_purposes': 'Kot udeleženec v programu MEPI dajem soglasje, da lahko Nacionalni urad MEPI in povezane organizacije vse fotografije uporabljajo za promocijske namene.',
  'label.you_can_send_activity_for_approval': 'Sedaj lahko dejavnost pošlješ v odobritev ocenjevalcu.',
  'label.you_can_send_activity_for_leader': 'Sedaj lahko svojo dejavnost pošlješ v odobritev mentorju.',
  'label.you_can_send_residential_project_to_leader': 'Sedaj lahko svoj projekt Neznani prijatelj pošlješ v odobritev mentorju.',
  'label.you_have_finished_now_send_to_approval': 'Tvoja dejavnost je zaključena. Sedaj jo lahko pošlješ v odobritev ocenjevalcu. Spodaj lahko dodaš tudi opombo.',
  'label.preparation_and_training': 'Priprave na odpravo',
  'label.you_will_be_redirected_to_the_payment': 'Klikni gumb »Plačaj« spodaj, da plačaš prek spleta z uporabo kartice Visa, kreditne kartice MasterCard ali bančne plačilne kartice Visa.',
  'label.you_will_be_the_first_award_leader': 'V svoji organizaciji boste koordinator. Imeli boste pravice, potrebne za dodajanje mentorjev in udeležencev ter vodenje postopkov v spletnem indeksu dosežkov.',
  'label.youll_receive_a_notification': 'Obvestili te bomo, ko bo tvoj mentor potrdil registracijo. V spletni indeks dosežkov se lahko vpišeš <a>tukaj</a> (dokler mentor ne bo potrdil tvoje registracije, imaš omejen dostop).',
  'label.your_parent_email': 'E-naslov starša/skrbnika',
  'label.your_parent_first_name': 'Ime starša/skrbnika',
  'label.your_parent_last_name': 'Priimek starša/skrbnika',
  'label.your_report_approve_now_send_to_leader': 'Tvoje poročilo je odobreno! Sedaj ga lahko pošlješ v odobritev mentorju. Spodaj lahko dodaš tudi opombo.',
  'label.there_are_loads_of_exciting_possibilities': 'Obstaja mnogo razburljivih možnosti in priložnosti. Izberi nekaj, za kar misliš, da te bo izpolnilo.',
  'label.your_residential_project_has_been_setup': 'Projekt Neznani prijatelj je ustvarjen in poslan v odobritev mentorju.',
  'label.your_report_has_been_sent_assessor': 'Poročilo je poslano v odobritev ocenjevalcu.',
  'label.your_report_has_been_sent_leader': 'Poročilo je poslano v odobritev mentorju.',
  'label.your_residential_project_is_complete': 'Projekt Neznani prijatelj je zaključen.',
  'label.to_work_on_the_online': 'Za uporabo spletnega indeksa dosežkov (ORB) potrebuješ osebni račun ORB.',
  'label.we_will_send_you_an_email': 'Poslali ti bomo e-sporočilo, ko bo registracija tvojega računa ORB odobrena.',
  'label.if_you_have_any_problems_or_doubts': 'Če imaš kakršnakoli vprašanja ali težave, se za več informacij obrni na svojo izvajalsko organizacijo.',
  'label.are_you_sure_you_want_to_leave': 'Ali zares želiš zapustiti stran? Podatki bodo izgubljeni.',
  'label.no_logs_yet': 'Ni dnevnikov.<br />S klikom gumba »Dodaj vnos« poskusi dodati svoj prvi dnevniški vnos.',
  'label.menu': 'Meni',
  'notifications.award_unit_has_been_created': 'Izvajalska organizacija je ustvarjena.',
  'notifications.authorization_code_is_not_valid': 'Avtorizacijska koda ni veljavna – videti je, da je bila že uporabljena.',
  'notifications.email_has_been_confirmed': 'E-naslov je potrjen.',
  'notifications.leader_has_been_created': 'Mentor je ustvarjen.',
  'notifications.participant_has_been_created': 'Udeleženec je ustvarjen.',
  'notifications.email_with_instructions_has_been_sent': 'E-sporočilo z navodili je bilo poslano.',
  'notifications.your_new_password_has_been_set': 'Novo geslo je bilo nastavljeno.',
  'notifications.success': 'Uspešno opravljeno.',
  'notifications.unknown_role': 'Neznana vloga',
  'notifications.waiting_for_approval': 'Čakanje na odobritev',
  'notifications.activity_cannot_be_created': 'Dejavnost ne more biti ustvarjena, dokler registracija ni odobrena.',
  'notifications.new_activity_has_been_added': 'Nova dejavnost je bila dodana.',
  'notifications.new_log_has_been_added': 'Nov vnos je bil dodan.',
  'notifications.log_has_been_deleted': 'Dnevniški vnos je bil izbrisan.',
  'notifications.log_has_been_modified': 'Dnevniški vnos je bil spremenjen.',
  'notifications.adventurous_journey_cannot_be_created_until_approved': 'Pustolovske odprave ni mogoče ustvariti, dokler registracija ni odobrena.',
  'notifications.new_participant_event_has_been_added': 'Nova dejavnost je bila dodana.',
  'notifications.participant_event_has_been_completed': 'Dejavnost je dokončana.',
  'notifications.training_and_practice_modified': 'Priprave na odpravo so spremenjene.',
  'notifications.completion_residential_project_completed': 'Projekt Neznani prijatelj je zaključen.',
  'notifications.new_residential_project_has_been_added': 'Nov projekt Neznani prijatelj je bil dodan.',
  'notifications.residential_project_cannot_be_created_until_approved': 'Projekta Neznani prijatelj ni mogoče ustvariti, dokler registracija ni odobrena.',
  'notifications.already_assessed_sent': 'Zahteva za odobritev mentorja je bila poslana.',
  'notifications.assessment_request_sent': 'Zahteva za ocenjevanje je bila poslana.',
  'notifications.leader_approval_sent': 'Zahteva za odobritev mentorja je bila poslana.',
  'tabs.logs': 'Dnevnik',
  'tabs.new': 'Novo',
  'tabs.overview': 'Pregled',
  'tabs.report': 'Poročilo',
  'button.add_activity': 'Dodaj dejavnost',
  'button.add_log': 'Dodaj dnevniški vnos',
  'button.continue_here': 'Nadaljuj tukaj',
  'button.continue': 'Nadaljuj',
  'button.continue_to_award': 'Nadaljuj k priznanju',
  'button.delete': 'Izbriši',
  'button.edit': 'Uredi',
  'button.edit_log': 'Uredi dnevniški vnos',
  'button.finish': 'Dokončaj',
  'button.forgot_your_password': 'Pozabljeno geslo?',
  'button.i_already_have_assessment': 'Oceno že imam.',
  'button.leave_anyway': 'Vseeno zapusti',
  'button.login': 'Prijava',
  'button.no': 'Ne',
  'button.register': 'Registracija',
  'button.send': 'Pošlji',
  'button.send_for_approval': 'Pošlji v odobritev',
  'button.setup': 'Nastavi',
  'button.setup_residential': 'Nastavi projekt Neznani prijatelj',
  'button.stay': 'Ostani',
  'button.submit': 'Pošlji',
  'button.update': 'Posodobi',
  'button.yes': 'Da',
  'errors.at_least_num_characters': 'Najmanjše št. znakov: {length}',
  'errors.do_not_match': 'Se ne ujemata',
  'errors.include_at_least_one_number': 'Vsebovati mora vsaj eno številko.',
  'errors.include_both_lower_and_upper_case': 'Vsebovati mora velike in male črke.',
  'errors.invalid_phone_format': 'Neveljavna oblika zapisa telefonske št.',
  'errors.invalid_email_address': 'Neveljaven e-naslov',
  'errors.required_field': 'Obvezno polje',
  'errors.must_be_at_least': 'Najmanjše št. znakov: {min}',
  'errors.must_be_no_more_than': 'Največje št. znakov: {max}',
  'errors.must_be_an_integer': 'Mora biti celo število',
  'errors.must_contain_at_least': 'Vsebovati mora vsaj eno številko.',
  'errors.must_include_at_least': 'Vsebovati mora vsaj eno veliko črko.',
  'errors.must_be_one_of': 'Biti mora eden od naštetih: {enums}',
  'errors.you_must_be_younger_than': 'Če se želiš registrirati v program, moraš biti mlajši/-a od {years} let in {months} mesecev. O tem se posvetuj z ekipo izvajalske organizacije.',
  'errors.you_must_be_older_than': 'Če se želiš registrirati v program, moraš biti mlajši/-a od {years} let in {months} mesecev. O tem se posvetuj z ekipo izvajalske organizacije.',
  'errors.email_address_is_in_use_please_sign': 'E-naslov je že v uporabi. Če se želiš registrirati na drugi stopnji, se vpiši v svoj račun.',
  'errors.email_address_is_in_use': 'E-naslov je že v uporabi.',
  'errors.sorry_we_already_have_this_email': "Račun s tem e-naslovom je že registriran. Če želiš začeti z naslednjo stopnjo,  <a href='/'>se vpiši v svoj račun</a> in izberi možnost »Začni naslednjo stopnjo«.",
  'wizard.authorising_contact': 'Zakoniti zastopnik organizacije',
  'wizard.award_leader_contact': 'Stik koordinatorja',
  'wizard.award_unit_details': 'Podrobnosti o izvajalski organizaciji',
  'wizard.contact_details': 'Kontaktni podatki',
  'wizard.contacts': 'Kontaktni podatki',
  'wizard.level': 'Stopnja programa',
  'wizard.level_selection': 'Izbira stopnje',
  'wizard.leader_details': 'Podatki o mentorju',
  'wizard.nominated_award_leader': 'Koordinator',
  'wizard.orb_account': 'Račun ORB',
  'wizard.parent_consent': 'Soglasje starša',
  'wizard.participant_details': 'Podrobnosti o udeležencu',
  'wizard.profile': 'Profil',
  'wizard.payment': 'Plačilo',
  'wizard.select_award_unit': 'Izbira države',
  'wizard.unit_details': 'Podrobnosti o organizaciji',
  'wizard.welcome': 'Pozdravljen/-a!',
  'wizard.your_details': 'Tvoji podatki',
  'awardUnit.do_you_want_to_create': 'Ali želiš registrirati novo izvajalsko organizacijo?',
  'parent.you_can_download_the_consent_here': 'Obrazec soglasja staršev lahko preneseš od tukaj, če ga še nimaš. Naj ga starši/skrbniki podpišejo, potem pa ga vrni mentorju.',
  'footer.copyright': '&copy; Lastnik avtorskih pravic: MEPI - Mednarodno priznanje za mlade 2017',
  'registration_participant.required_award_payment': 'Pristopnina je obvezna.',
  'registration_participant.pay_online_here': 'Plačilo je mogoče prek spleta. ID za transakcijo je na voljo tukaj.',
  'dashboard.activity_log_time': '{hours} h {minutes} min',
  'moduleTitle.award_completed': 'Stopnja MEPI zaključena!',
  'notifications.award_approval_request_sent_to_leader': 'Zahteva po odobritvi priznanja je bila poslana mentorju.',
  'notifications.new_participant_event_has_been_completed': 'Nova dejavnost je opravljena.',
  'notifications.preparation_and_training_approval_sent': 'Odobritev priprav na odpravo je bila poslana.',
  'notifications.reparation_and_training_completed': 'Priprave na odpravo so opravljene.',
  'notifications.your_profile_photo_has_been_edited': 'Urejanje profilne fotografije je končano.',
  'notifications.your_profile_has_been_edited': 'Urejanje profila je končano.',
  'notifications.new_level_has_started': 'Dejavnosti na naslednji stopnji so se začele.',
  'notifications.activity_has_been_edited': 'Urejanje dejavnosti je končano.',
  'notifications.you_have_been_logged_out': 'Odjavljanje ...',
  'notifications.logging_out': 'Odjava je bila uspešna.',
  'label.you_can_send_award_to_leader': 'Priznanje lahko pošlješ v odobritev mentorju.',
  'label.you_have_completed_all_sections_of_your_award': 'Vsa področja programa so zaključena. Sedaj lahko podatke pošlješ v odobritev mentorju. Spodaj lahko dodaš tudi opombo.',
  'label.you_have_now_completed_your_award': 'Priznanje ({level}) je zaključeno. Ali želiš začeti z dejavnostmi na naslednji stopnji?',
  'label.congratulation_your_award_has_been_approved': 'Čestitke. Priznanje ({level}) je odobreno! <br /> Če želiš, lahko že začneš z naslednjo stopnjo.',
  'moduleTitle.settings': 'Nastavitve',
  'moduleTitle.edit_activity': 'Uredi dejavnost',
  'moduleTitle.select_your_major_activity': 'Izberi glavno dejavnost',
  'label.settings': 'Nastavitve',
  'label.major_activity_means_that_you_will': 'Glavna dejavnost pomeni, da je v primerjavi z drugimi za to dejavnost treba porabiti več časa. Na zlati in srebrni stopnji to pomeni šest mesecev, na bronasti stopnji pa tri mesece.',
  'label.notifications': 'Obvestila',
  'label.my_award': 'Moj MEPI',
  'label.physical_recreation': 'Rekreativni šport',
  'label.skill': 'Veščine',
  'label.service': 'Prostovoljstvo',
  'label.my_parent_will_complete_and_sign_form': 'Moji starši/skrbniki bodo izpolnili in podpisali obrazec za soglasje starša.',
  'label.please_print_it_tak_it_to_your_parent': 'Natisni obrazec, odnesi ga staršem/skrbnikom, da ga podpišejo, nato pa ga oddaj mentorju.',
  'label.change_password': 'Sprememba gesla',
  'label.change_major_activity': 'Sprememba glavnega področja',
  'title.change_password': 'Spremeni geslo',
  'label.old_again': 'Staro geslo',
  'label.new_password': 'Novo geslo',
  'label.new_password_again': 'Vnovičen vnos gesla',
  'errors.passwords_dont_match': 'Gesli se ne ujemata',
  'errors.more_than': 'Več kot: {limit}',
  'button.parent_guardian_consent_pdf': 'Soglasje_starša/skrbnika.pdf',
  'button.send_award_for_approval': 'Pošlji priznanje v odobritev',
  'button.send_report': 'Pošlji poročilo',
  'button.terms_and_conditions': 'Mednarodni pogoji',
  'button.privacy_policy': 'Pravilnik o zasebnosti',
  'button.save': 'Shrani',
  'button.start_new_level': 'Začni naslednjo stopnjo',
  'button.change_password': 'Zamenjaj geslo',
  'button.edit_activity': 'Uredi dejavnost',
  'moduleTitle.file_upload': 'Nalaganje datoteke',
  'label.add_file': 'Dodajanje datoteke',
  'label.description': 'Opis',
  'label.waiting_for_office_sign_off': 'Čakanje na potrditev nacionalnega urada.',
  'notifications.file_has_been_uploaded': 'Datoteka je bila naložena.',
  'tabs.files': 'Datoteke',
  'button.upload': 'Naloži',
  'button.upload_file': 'Naloži datoteko',
  'button.add_file': 'Dodaj datoteko',
  'button.this_activity_has_no_assessor': 'Ta dejavnost nima ocenjevalca. Dodaj podatke o ocenjevalcu, preden jo pošllješ v odobritev.',
  'label.i_want_to_register_my_award': 'Svojo izvajalsko organizacijo želim registrirati kot neodvisni center MEPI.',
  'label.select_sub_operating_authority': 'Izbira partnerskega urada',
  'label.your_must_first_setup_some_activity': 'Najprej je treba ustvariti dejavnost.',
  'label.you_cant_change_your_major_activity': 'Ne moreš spremeniti glavne dejavnosti, ker je bila glavna dejavnost že zaključena.',
  'label.s_specific': '<b>S – specifičen: Tvoj cilj ne sme biti zastavljen preveč široko.</b> Namesto, da rečeš: »Hočem bolje igrati violino,« lahko rečeš: »Na violino se želim naučiti lestvico F.«',
  'label.m_measurable': '<b>M – merljiv: Vedeti moraš, kdaj je tvoj cilj dosežen.</b> Namesto, da cilj zastaviš kot »Hočem pomagati skupnosti«, lahko rečeš: »Hočem pomagati brezdomcem tako, da enkrat na teden prostovoljno pomagam v razdeljevalnici hrane.« Na ta način cilj lahko preizkusiš.',
  'label.a_achievable': '<b>A – dosegljiv: Tvoj cilj mora biti nekaj, kar lahko dosežeš v časovnem okviru, ki je določen za posamezno stopnjo programa.</b> Namesto, da rečeš: »Hočem izkoreniniti revščino,« bi bilo bolje zastaviti bolj dosegljiv cilj. Recimo: »Hočem zbrati sredstva in jih poslati v neko vas v nerazvitem svetu ter tako omiliti posledice revščine.«',
  'label.r_realistic': '<b>R – relevanten/pomemben: Cilj naj bo pomemben za doseganje tvoje vizije.</b> Če bo cilj zate res pomemben, potem ti bo tudi prinesel ustrezno zadovoljstvo.',
  'label.t_timely': '<b>T – časovno določen: Pri zastavljenem cilju moraš določiti, do kdaj bi ga rad/-a zaključil/-a.</b> Tvoj cilj je lahko na primer: »Na violino se hočem naučiti lestvico F v treh mesecih.«',
  'label.you_can_upload_here_any_files': 'Sem lahko naložiš vse datoteke (največja velikost 10 MB), ki jih želiš deliti s svojim mentorjem.',
  'moduleTitle.login_change': 'Sprememba prijave',
  'notifications.adventurous_journey_modified': 'Pustolovska odprava je bila spremenjena.',
  'tabs.sections': 'Področja',
  'label.change_email': 'Sprememba e-naslova',
  'title.change_email': 'Sprememba e-naslova',
  'label.new_email': 'Nov e-naslov',
  'label.new_email_again': 'Potrditev novega e-naslova',
  'errors.emails_dont_match': 'E-naslova se ne ujemata',
  'button.change_email': 'Spremeni e-naslov',
  'notifications.email_with_instructions_has_been_sent_to_your_inbox': 'E-sporočilo z navodili je bilo poslano v tvoj nabiralnik.',
  'global.dofe_name': 'Mednarodno priznanje za mlade',
  'global.or': 'ali',
  'route.landing_page': 'Ciljna stran',
  'route.dashboard': 'Začetna stran',
  'moduleTitle.notifications': 'Obvestila',
  'moduleTitle.no_notifications': 'Ni obvestil',
  'moduleTitle.new_notifications': 'Nova obvestila',
  'moduleTitle.older_notifications': 'Starejša obvestila',
  'moduleTitle.user_guide': 'Uporabniški priročniki',
  'label.user_guide': 'Uporabniški priročniki',
  'notifications.your_password_has_been_changed': 'Geslo je bilo spremenjeno.',
  'label.country': 'Država',
  'label.on_your_smartphone': 'Na pametnem telefonu',
  'label.on_the_web': 'Na spletu',
  'label.orb_online': 'ORB na spletu',
  'label.language': 'Jezik',
  'moduleTitle.participant_login': 'Prijava za udeležence',
  'label.for_ios': 'za iOS',
  'label.for_android': 'za Android',
  'button.login_as_award_staff': 'Prijavi se kot izvajalec',
  'errors.leader_doesnt_exist': 'Mentor ne obstaja',
  'global.loading': 'Nalaganje',
  'moduleTitle.award_staff_login': 'Prijava za izvajalce',
  'formTitle.residential_project_details': 'Podrobnosti o PNP',
  'label.you_can_also_download_participant': 'Preneseš lahko tudi čisto novo <strong>aplikacijo za udeležence</strong>, prek katere lahko do spletnega indeksa dosežkov dostopaš kadarkoli in kjerkoli.',
  'label.you_can_also_download_leader': 'Lahko prenesete tudi čisto novo <strong>aplikacijo za mentorje</strong>, prek katere lahko do spletnega indeksa dosežkov dostopate kadarkoli in kjerkoli.',
  'notifications.this_role_is_not': 'Ta vloga trenutno ni podprta.',
  'notifications.residential_project_has_been_updated': 'Program Neznani prijatelj je posodobljen.',
  'tabs.participant': 'Udeleženci',
  'tabs.award_staff': 'Izvajalci',
  'moduleTitle.edit_residential_project': 'Urejanje programa Neznani prijatelj',
  'button.residential_project': 'Uredi program Neznani prijatelj',
  'notifications.your_login_email_has_been_changed': 'Prijavni e-naslov je bil spremenjen.',
  'meta.dofe_name': 'Mednarodno priznanje za mlade',
  'notifications.unknown_role_leader': 'Neznana vloga – uporabi prijavo za izvajalce',
  'notifications.unknown_role_participant': 'Neznana vloga – uporabi prijavo za udeležence',
  'label.user_guide_web_participant': 'Spletni up. priročnik – udeleženec',
  'label.user_guide_app_participant': 'Up. priročnik za aplikacijo – udeleženec',
  'label.note_for_supervisor': 'Opomba za spremljevalca',
  'label.before_submitting_your_aj': 'Preden pošlješ odpravo mentorju, jo mora odobriti {role}. Če hočeš, lahko dodaš tudi opombo.',
  'button.back_to_home': 'Začetna stran',
  'moduleTitle.assessor_approval': 'Odobritev za: {role}',
  'label.this_aj_has_no_assessor': 'Za to pustolovsko odpravo manjka {role}. Dodaj podatke, preden odpravo pošlješ v odobritev.',
  'route.not_found': 'Ni najdeno',
  'notifications.are_you_sure': 'Si prepričan/-a?',
  'button.cancel': 'Prekliči',
  'label.add_document': 'Dodajanje dokumenta',
  'errors.there_are_currently_no_details_for_your': 'Tvoj {role} še nima podatkov. Vnesi manjkajoče podatke, preden dejavnost pošlješ v odobritev.',
  'moduleTitle.missing_data': 'Manjkajoči podatki',
  'label.to_send_assessment_request': 'Če želiš oceno poslati elektronsko, vnesi e-naslov prejemnika ({role}).',
  'label.pending_changes': 'Spremembe na čakanju ...',
  'label.some_fields_require': 'Nekaj polj je treba pregledati.',
  'roles.assessor': 'Ocenjevalec',
  'roles.supervisor': 'Spremljevalec',
  'pageTitle.register_participant': 'Registracija udeleženca',
  'moduleTitle.revise_message': 'Pregled sporočila',
  'moduleTitle.payment_for_level': 'Pristopnina – ({awardLevel})',
  'moduleTitle.payment': 'Plačilo pristopnine za udeleženca',
  'moduleTitle.we_have_sent_you_payment_link': 'Poslali smo ti e-sporočilo s povezavo, na kateri lahko zaključiš plačilo.',
  'label.required_award_payment': 'Pristopnina je obvezna',
  'label.payment_fees': 'Pristojbina za plačilo',
  'label.payment_method': 'Način plačila',
  'label.you_will_type_trans_id': 'Zahtevan bo ID transakcije.',
  'label.any_level_previously': 'Že zaključena stopnja',
  'label.registering_for_level': 'Registracija za stopnjo',
  'notification.payment_link_expired': 'Povezava za plačilo je potekla',
  'button.pay': 'Plačaj',
  'label.registration_updated': 'Registracija je bila posodobljena, sedaj lahko zapreš to stran.',
  'label.award_leader_receive_payment': 'Mentor bo prejel informacijo o plačilu.',
  'errors.end_date_after': 'Datum konca mora biti po datumu začetka.',
  'button.back': 'Nazaj',
  'button.edit_info': 'Uredi podatke',
  'moduleTitle.level_detail': 'Podatki o stopnji',
  'label.payment_methods': 'Načini plačila',
  'label.address': 'Naslov',
  'note.review_filled_participant': 'Preglejte podatke, ki jih je vnesel udeleženec. Če so v njih napake, jih lahko popravite.',
  'moduleTitle.payment_successful': 'Plačilo registracije za udeleženca je bilo uspešno.',
  'button.proceed_to_login': 'Nadaljuj s prijavo',
  'label.add_additional_activity': 'Dodajanje dodatne dejavnosti',
  'moduleTitle.welcome_to_orb': 'To je tvoj spletni indeks dosežkov.',
  'empty_dashboard.not_approved': 'To orodje ti bo pomagalo beležiti napredek v programu, a mentor še ni odobril tvojega profila. Preden začneš ustvarjati svojo prvo dejavnost, moraš počakati na odobritev.',
  'empty_dashboard.approved_1': 'To orodje ti bo pomagalo beležiti napredek v programu.',
  'empty_dashboard.approved_2': 'Najprej moraš ustvariti dejavnost. Začneš tako, da klikneš na eno dejavnost na levi. Če potrebuješ pomoč z ustvarjanjem dejavnosti, se obrni na mentorja.',
  'label.discuss_activity_leader': 'Če želiš izbrati več kot eno dejavnost, se o tem najprej pogovori z mentorjem.',
  'label.cannot_add_activity': 'V tej kategoriji lahko dodaš največ 3 dejavnosti. O tem se pogovori s svojim mentorjem.',
  'button.ok': 'V redu',
  'label.payment_was_canceled': 'Uporabnik je preklical plačilo.',
  'label.problem_with_payment': 'Pri obdelavi plačila je prišlo do napake. Obrnite se na nacionalni urad.',
  'pageTitle.register_leader': 'Registracija mentorja',
  'pageTitle.registration_complete': 'Registracija zaključena',
  'label.payment_link_expired_or_paid': 'Pristopnina je že poravnana ALI pa je povezava do plačila potekla.',
  'label.contact_nao_assistance': 'Za pomoč se obrnite na nacionalni urad.',
  'label.send_required_amount_to_your_award_leader': 'Znesek pristopnine pošlji mentorju ali koordinatorju v svoji izvajalski organizaciji.',
  'label.fee_can_be_paid': 'Prijavnino je mogoče poravnati prek spleta s kartico VISA, MasterCard ali drugimi kreditnimi/bančnimi plačilnimi karticami.',
  'notifications.login_failed_right_tab': 'Prijava ni bila uspešna. Preverite, ali ste za prijavo izbrali pravi zavihek (udeleženec/izvajalec).',
  'label.i_have_read_privacy_policy': 'Prebral/-a sem pravilnik o zasebnosti in se strinjam z določili.',
  'errors.invalid_date_format': 'Nepravilna oblika zapisa datuma',
  'label.no_privacy_policy': 'Nadaljuj s klikom gumba za dokončanje.',
  'label.status': 'Stanje',
  'moduleTitle.attached_with_observation': 'Pripeto skupaj z opažanji',
  'moduleTitle.revise_message_rp': 'Tvoj mentor je pregledal tvoj projekt Neznani prijatelj.',
  'file.activity_section_summary': '{section}-podrocje-povzetek',
  'label.download_section_summary': 'Prenos povzetka področja',
  'label.award_summary': 'Povzetek udeležbe v programu',
  'btn.download_summary_for_assessor': 'Prenesi povzetek za ocenjevalca',
  'label.first_activity_started': 'Opravljanje prve dejavnosti se je začelo.',
  'label.hours_completed_required': 'Št. dokončanih/zahtevanih ur',
  'label.weeks_completed_required': 'Št. dokončanih/zahtevanih tednov',
  back_to_home: 'Začetna stran',
  'label.activity_rejected_click': 'Mentor ni odobril tvoje dejavnosti. Klikni za:',
  'button.more_information': 'Več informacij',
  'label.attached_file': 'Priložena datoteka',
  'moduleTitle.journey_details': 'Podrobnosti o odpravi',
  'tabs.activity': 'Dejavnost',
  'label.confirm_email': 'Potrditev e-naslova',
  'label.aj_rejected_click': 'Mentor ni odobril tvoje odprave. Klikni za:',
  'label.verifying_payment': 'Preverjanje plačila',
  'button.finish_and_pay': 'Končaj in plačaj',
  'label.payment_not_successful_text': 'Ker plačilo pristopnine ni bilo uspešno opravljeno, ga je treba opraviti zdaj.',
  'label.payment_not_completed': 'Plačilo ni opravljeno',
  'button.pay_now': 'Plačaj zdaj',
  'label.registration_pending_parental_consent': 'Za dokončanje registracije je treba pridobiti soglasje starša/skrbnika.',
  'button.edit_observation': 'Uredi opažanja',
  'moduleTitle.qualifying': 'Kvalifikacijska',
  'moduleTitle.practice': 'Poskusna',
  'label.first_log_entry': 'Prvi dnevniški vnos',
  'label.first_log_entry_date': 'Datum prvega dnevniškega vnosa',
  'label.last_log_entry': 'Zadnji dnevniški vnos',
  'label.last_log_entry_date': 'Datum zadnjega dnevniškega vnosa',
  'label.you_can_send_journey_report_for_approval': 'Poročilo odprave ({journey}) lahko pošlješ v odobritev.',
  'button.edit_and_resend_report': 'Uredi in ponovno pošlji poročilo',
  'label.your_journey_is_complete': 'Tvoja odprava ({journeyType}) je opravljena.',
  'button.add_additional_journey': 'Dodaj dodatno odpravo',
  'moduleTitle.edit_journey': 'Uredi odpravo',
  'notifications.assessment_sent': 'Ocena je bila poslana.',
  'notifications.file_is_too_big': 'Datoteke ni bilo mogoče naložiti. Največja dovoljena velikost datoteke je 10 MB.',
  'notifications.authorization_code_has_expired': 'Avtorizacijska koda je zaradi varnosti potekla. Zahtevajte novo kodo.',
  'route.confirm_email': 'Potrdi e-naslov',
  'label.assessor_needs_account': 'Za uporabo spletnega indeksa dosežkov (SID) je treba imeti osebni račun SID.<br/>Poverilnice lahko ustvarite tukaj',
  'label.company_name': 'Ime podjetja',
  'label.secondary_email_again': 'Potrditev dodatnega e-naslova',
  'label.how_many_years': 'Koliko let/mesecev?',
  'label.no_company_leave_empty': 'Če ne delate za nobeno podjetje, pustite prazno.',
  'label.secondary_phone_number': 'Dodatna telefonska številka',
  'label.secondary_phone_type': 'Vrsta dodatnega telefona',
  'label.wwc_application_number': 'Številka potrdila o nekaznovanosti',
  'label.wwc_expiration_date': 'Datum poteka veljavnosti potrdila o nekaznovanosti',
  'label.you_are_now_registering_as_assessor': 'Registrirali se boste kot ocenjevalec.',
  'label.you_have_finished_aj_now_send_to_approval': 'Tvoja pustolovska odprava je zaključena. Sedaj jo lahko pošlješ v odobritev ocenjevalcu. Spodaj lahko dodaš tudi opombo.',
  'label.your_experience': 'Izkušnje',
  'label.your_qualification': 'Izobrazba',
  'notifications.waiting_for_assessor_approval': 'Čakanje na odobritev ocenjevalca',
  'button.resend_assessment_request': 'Ponovno pošlji zahtevo za ocenjevanje',
  'errors.emails_must_be_different': 'Dodatni e-naslov se mora razlikovati od prvega.',
  'moduleTitle.company_details': 'Podatki o podjetju',
  'notifications.already_resent_assessment_request': 'Zahteva za ocenjevanje je bila že ponovno poslana.',
  'route.assessor_dashboard': 'Začetna stran za ocenjevalca',
  'pageTitle.register_assessor': 'Registracija ocenjevalca',
  'wizard.assessor_details': 'Podatki o ocenjevalcu',
  'wizard.assessor_experience': 'Izkušnje ocenjevalca',
  'wizard.personal_details': 'Osebni podatki',
  'button.sign_off': 'Potrdi',
  'button.sign_off_dashed': 'Potrdi',
  'moduleTitle.sign_off': 'Potrditev',
  'label.certify_participant_met_reqs': 'Kot ocenjevalec te dejavnosti potrjujem, da je udeleženec izpolnil zahteve.',
  'label.assessor_report': 'Poročilo ocenjevalca',
  'label.content_update': 'Prosimo, počakajte. Vsebina se posodablja ...',
  'label.comment_on_participant_improvement': 'Napišite komentar o napredku/udejstvovanju/predanosti udeleženca.',
  'note.edit_participant_review': 'Če želite popraviti podatke, kliknite gumb »Uredi podatke«.',
  'errors.min_age': 'Najnižja starost je: {age}',
  'notifications.assessor_link_expired': 'Povezava za registracijo ocenjevalca je potekla.',
  'label.secondary_email': 'Dodatni e-naslov',
  'moduleTitle.review_participant_info': 'Preglej podatke o udeležencu',
  'label.loading_payment_gateway': 'Nalaganje povezave za dokončanje plačila',
  'label.consent_given_login_as_child': 'Soglasje je bilo že poslano. Vpišite se kot svoj otrok.',
  'notifications.only_one_qualification_journey_per_award': 'V okviru posamezne stopnje programa je mogoče določiti le eno kvalifikacijsko odpravo.',
  'label.registration_fees_participant': 'Plačilo pristopnine – {name} (#{id})',
  'moduleTitle.leader_details': 'Podatki o mentorju',
  'label.leader_name': 'Ime mentorja',
  'label.leader_phone': 'Telefon mentorja',
  'label.leader_email': 'E-naslov mentorja',
  'moduleTitle.au_details': 'Podatki o izvajalski organizaciji',
  'label.au_name': 'Ime izvajalske organizacije',
  'label.assessor_guidelines': 'Smernice',
  'label.assessor_cond_req': 'Ključni pogoji in zahteve',
  'label.assessor_ref_handbook': 'Glejte priročnik o programu MEPI',
  'label.assessor_ref_online_modules': 'Glejte spletne module tečajev',
  'label.participant_has_no_aj_report': 'Udeleženec še ni poslal poročila.',
  'moduleTitle.participant_details': 'Podatki o udeležencu',
  'label.participants_has_no_logs': 'Udeleženec še nima dnevniških vnosov.',
  'label.location_type': 'Vrsta kraja',
  'label.activity_ready_for_signoff': 'Ta dejavnost čaka na potrditev.',
  'label.activities': 'Dejavnosti',
  'label.choose_how_you_want_to_login': 'Izberite način prijave:',
  'roles.leader': 'Mentor',
  'roles.award_verifier': 'Overitelj priznanja',
  'roles.coordinator': 'Koordinator',
  'roles.aj_assessor': 'Ocenjevalec pustolovske odprave',
  'roles.aj_supervisor': 'Spremljevalec pustolovske odprave',
  'roles.instructor': 'Področni inštruktor',
  'roles.nao_staff': 'Ekipa Nacionalnega urada MEPI',
  'roles.super_user': 'Up. s polnimi pooblastili',
  'roles.user': 'Uporabnik',
  'roles.viewer': 'Up. z osnovnimi pooblastili',
  'roles.authorizing_contact': 'Zakoniti zastopnik organizacije',
  'roles.if_staff_superuser': 'Up. s polnimi pooblastili (NUM)',
  'roles.if_staff_statistical_user': 'Up. statističnih funkcij (NUM)',
  'roles.if_staff_viewer': 'Up. z osnovnimi pooblastili (NUM)',
  'roles.aj_instructor': 'Voditelj odprav',
  'label.if_you_have_questions_au': 'Če imate vprašanja glede registracije, se obrnite na izvajalsko organizacijo.',
  'label.we_will_send_you_an_email_leader': 'Ko bo registracija vašega računa SID odobrena, vam bomo poslali e-poštno sporočilo.',
  'moduleTitle.rejecting_assessor_invitation': 'Zavrnitev vabila za ocenjevanje',
  'notifications.assessor_invitation_rejected': 'Vabilo za ocenjevanje je bilo zavrnjeno.',
  'moduleTitle.participants_list_is_empty': 'Seznam udeležencev je prazen.',
  'label.note_from_participant': 'Opomba udeleženca',
  'label.you_can_send_aj_to_leader': 'Sedaj lahko svojo pustolovsko odpravo pošlješ v odobritev mentorju.',
  'button.save_report': 'Shrani poročilo',
  'label.this_activity_has_no_assessor': 'Ta dejavnost nima ocenjevalca. Nastavi podatke o ocenjevalcu, preden dejavnost pošlješ v odobritev.',
  'label.activity_rejected_click_by_assessor': 'Ocenjevalec je zavrnil tvojo dejavnost. Klikni za:',
  'button.reject': 'Zavrni',
  'button.reject_invitation': 'Zavrni vabilo',
  'label.reason': 'Razlog',
  'label.accept_invitation_and_continue': 'Sprejmi vabilo in nadaljuj',
  'pageTitle.registration_reject': 'Zavrnitev registracije',
  'errors.you_must_be_older_than_register_for_leader': 'Če se želite registrirati kot mentor, morate biti starejši od {years} let in {months} mesecev.',
  'label.your_report_approve_now_send_to_leader_without_note': 'Tvoje poročilo je odobreno! Sedaj ga lahko pošlješ v odobritev mentorju.',
  'button.stop_assessing_this_activity': 'KONČAJ OCENJEVANJE DEJAVNOSTI',
  'button.confirm': 'Potrdi',
  'moduleTitle.are_you_sure': 'Ali ste prepričani?',
  'label.content_restore': 'Obnovitev vsebine',
  'button.stop_editing': 'Končaj urejanje',
  'notifications.activity_has_been_rejected': 'Dejavnost je bila zavrnjena.',
  'notifications.aj_has_been_rejected': 'Pustolovska odprava je bila zavrnjena.',
  'notifications.rp_has_been_rejected': 'Projekt Neznani prijatelj je bil zavrnjen.',
  'moduleTitle.additional_files': 'Dodatne datoteke',
  'moduleTitle.no_additional_files': 'Dodatne datoteke',
  'moduleTitle.stop_assessing_section': 'Prekinitev ocenjevanja področja',
  'label.show_security_and_refund_policy': 'Prikaži določila pravilnika o varnostnih ukrepih in povračilu plačila',
  'moduleTitle.security_and_refund_policy': 'Pravilnik o varnostnih ukrepih in o povračilu plačila',
  'label.fees_payment': 'Plačilo',
  'label.redund_policy': 'Pravilnik o povračilu plačila',
  'label.security_policy': 'Pravilnik o varnostnih ukrepih',
  'label.leave_blank': 'Pustite prazno',
  'label.frequently_asked_questions': 'Pogosta vprašanja',
  'label.language_selection_is_disabled_for_iac': 'Izbira jezika za neodvisne centre MEPI ni na voljo.',
  'errors.min_nights_required': 'Najmanjše število obveznih noči: {nights}.',
  'label.completion_date': 'Datum zaključka',
  'label.you_are_offline': 'Ni omrežne povezave. Spremembe morda ne bodo shranjene.',
  'errors.start_date_after_award_start': 'Datum začetka ne more biti pred začetkom trenutne stopnje programa.',
  'label.participants': 'Udeleženci',
  'label.marketing_from_iaf': 'Želim prejemati promocijsko gradivo Nacionalnega urada MEPI.',
  'label.marketing_from_oa': 'Želim prejemati promocijsko gradivo nacionalnega urada.',
  'label.marketing_from_nao': 'Želim prejemati promocijsko gradivo Nacionalnega urada MEPI.',
  'label.select_iac': 'Izberite neodvisni center MEPI',
  'label.you_will_be_redirected_to_the_paypal_payment': 'Kliknite zgornji gumb »Plačaj«, če želite opraviti spletno plačilo s kartico Visa, kreditno kartico MasterCard, bančno plačilno kartico Visa ali prek računa PayPal.',
  'notifications.report_has_been_sent': 'Poročilo je bilo poslano.',
  'label.processing_paypal_payment': 'Obdelava plačila prek storitve PayPal',
  'label.loading_paypal_gateway': 'Nalaganje plačilnega prehoda storitve PayPal',
  'label.payment_failed': 'Plačilo ni bilo uspešno.',
  'label.payment_has_been_cancelled': 'Plačilo je bilo preklicano ali ni bilo uspešno.',
  'roles.naa_oa_staff': 'Ekipa Nacionalnega urada MEPI',
  'label.download_report_and_upload_signed_version': 'Prenesite poročilo in naložite podpisano različico.',
  'button.download_summary_for_assessor': 'Prenesite povzetek za ocenjevalca',
  'label.pay_online_mastercard': 'Spletno plačilo',
  'label.pay_online_paypal': 'Spletno plačilo',
  'notifications.authorization_code_is_missing': 'Manjka avtorizacijska koda',
  'errors.unknown_payment_error': 'Pri plačilu je prišlo do neznane napake.',
  'errors.already_in_use_by_auth_contact': 'Ta e-poštni naslov že uporablja zakoniti zastopnik organizacije.',
  'roles.if_staff_stat_user': 'Up. statističnih funkcij (NUM)',
  'moduleTitle.you_have_been_logged_out_due_to_inactivity': 'Zaradi nedejavnosti si bil/-a odjavljen/-a.',
  'announcement.survey_description.do_think_people_are_lazy': 'Ali mislite, da so mladi leni ali ošabni? Vabimo vas, da ne glede na svojo starost izpolnite eno od naših svetovnih anket in nam poveste, kaj VI mislite o današnji mladini.',
  'announcement.survey_title.join_our_global_survey': 'Pridružite se svetovni anketi',
  'announcement.survey_button.if_below_25': 'Od 16 do 25 let',
  'announcement.survey_button.if_over_25': 'Več kot 25 let',
  'moduleTitle.privacy_and_cookie_policy': 'Pravilnik o zasebnosti in piškotkih',
  'label.we_have_made_some_important_changes': 'Vnesli smo nekaj pomembnih sprememb v naš pravilnik o zasebnosti in piškotkih, zato želimo, da veste, kaj to pomeni za vas in vaše podatke.',
  'button.i_agree': 'Strinjam se',
  'button.see_more_details': 'Želim izvedeti več',
  'label.the_cookie_settings_on_this': 'Piškotki na tem spletnem mestu so nastavljeni na možnost »Dovoli piškotke«, kar zagotavlja najboljšo izkušnjo brskanja. Če nadaljujete z uporabo tega spletnega mesta, ne da bi spremenili nastavitve piškotkov, ali spodaj kliknete »Sprejmi«, se strinjate z zgoraj navedeno nastavitvijo.',
  'label.after_your_rp_describe': '',
  'label.you_are_going_to_be_logged_out': ''
}
